import template from './users-list.html';
import controller from './users-list.controller';
import './users-list.styl';

const usersListComponent = {
  template,
  controller,
  controllerAs: 'usersList',
  bindings: {
    users: '='
  },
  require: {
    app: '^^app'
  }
};

export default usersListComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-list/users-list.component.js
 **/